import { basicURL } from "../../apiManager/APIConfig";
import { store } from "../../redux/store";

async function request(path, { method = "GET", body, viewerToken, auth = false } = {}) {
  const headers = {};
  if (body) headers["Content-Type"] = "application/json";
  if (viewerToken) headers["X-Viewer-Session"] = viewerToken;
  if (auth) {
    const token = store.getState().auth?.access_token;
    if (token && token !== "undefined") headers.Authorization = `Bearer ${token}`;
  }
  const response = await fetch(`${basicURL}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await response.json().catch(() => ({}));
  return { ok: response.ok, status: response.status, ...data, data: data?.data, message: data?.message };
}

export const GetPresentationShareCall = (titleId) =>
  request(`presentations/${titleId}/share`, { auth: true });

export const UpdatePresentationShareModeCall = (titleId, mode) =>
  request(`presentations/${titleId}/share`, { method: "PUT", body: { mode }, auth: true });

export const AddPresentationInvitesCall = (titleId, emails) =>
  request(`presentations/${titleId}/share/invites`, {
    method: "POST",
    body: { emails },
    auth: true,
  });

export const RemovePresentationInviteCall = (titleId, inviteId) =>
  request(`presentations/${titleId}/share/invites/${inviteId}`, {
    method: "DELETE",
    auth: true,
  });

export const GetSharedPresentationCall = (token) =>
  request(`presentations/shared/${encodeURIComponent(token)}`);

export const RequestPresentationCodeCall = (token, email) =>
  request(`presentations/shared/${encodeURIComponent(token)}/request-code`, {
    method: "POST",
    body: { email },
  });

export const VerifyPresentationCodeCall = (token, email, code) =>
  request(`presentations/shared/${encodeURIComponent(token)}/verify-code`, {
    method: "POST",
    body: { email, code },
  });

export const GetSharedPresentationSlidesCall = (token, viewerToken) =>
  request(`presentations/shared/${encodeURIComponent(token)}/slides`, { viewerToken });
